import React, { useState, useEffect, useContext, useRef } from "react";
import {
  Container,
  makeStyles,
  TableBody,
  TableHead,
  TablePagination,
  Grid,
} from "@material-ui/core";
import {
  Toast,
  ConfirmationModal,
  EditUser,
  AddUser,
  SimpleToolbar,
  Loader,
  Drawer,
  BaseTable,
  StyledTableCell,
  StyledTableRow,
} from "../components";
import { userServices } from "../services";
import { AuthContext } from "../context";
import { useDrawer } from "../hooks";
import {
  EditIconButton,
  EnableDisableIconButton,
  DeleteIconButton,
} from "../components/icon-buttons";
import handleDownloadExcel from "../helpers/download-excel";

export default function AdminsScreen(props) {
  const classes = useStyles();
  const [limit, setLimit] = useState(100);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const { authState, signOut } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [users, setUsers] = useState([]);
  const [userToDelete, setUserToDelete] = useState(null);
  const [openAlert, setOpenAlert] = useState(false);
  const [userToEdit, setUserToEdit] = useState(null);
  const [openEditUserModal, setOpenEditUserModal] = useState(false);
  const [openAddUserModal, setOpenUserModal] = useState(false);
  const [reload, setReload] = useState(false);
  const { isOpen, setIsOpen } = useDrawer();

  const tableHeader = useRef(["Usuario", "Correo", "Estado"]);
  const tableBody = useRef([]);
  useEffect(() => {
    const tableData = users.map((user) => {
      return {
        Usuario: user.username,
        Correo: user.email,
        Estado: user.status ? "Activo" : "Inactivo",
      };
    });
    tableBody.current = tableData;
  }, [users]);

  useEffect(() => {
    // async function getUsers() {
    //   setReload(false);
    //   try {
    //     setLoading(true);
    //     const { status, response } = await userServices.getUsers({
    //       token: authState.token,
    //       page,
    //       limit,
    //     });
    //     setLoading(false);
    //     if (status === 200) {
    //       setUsers(response.users);
    //       setLimit(response.limit);
    //       setCount(response.total);
    //       setPage(response.page);
    //     } else if (status === 401) {
    //       signOut();
    //     }
    //   } catch (e) {
    //     setLoading(false);
    //     console.log(e);
    //   }
    // }
    getUsers();
  }, [page, limit, authState, reload, signOut]);

  const getUsers = async (text = "") => {
    setReload(false);
    try {
      setLoading(true);
      const { status, response } = await userServices.getUsersFilter({
        token: authState.token,
        text,
        page,
        limit,
      });
      setLoading(false);
      if (status === 200) {
        setUsers(response.users);
        setLimit(response.limit);
        setCount(response.total);
        setPage(response.page);
      } else if (status === 401) {
        signOut();
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  const updateStatus = async (user) => {
    const status = !user.status;
    try {
      setLoading(true);
      const { status: statusResp } = await userServices.updateUserStatus({
        token: authState.token,
        status,
        _id: user._id,
      });
      setLoading(false);
      if (statusResp === 200) {
        setReload(true);
        setToast(true);
        setToastMessage("Usuario actualizado con exito");
      } else if (status === 401) {
        signOut();
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  const deleteUser = async () => {
    // console.log({ userToDelete });
    try {
      setLoading(true);
      const { status, response } = await userServices.deleteUser({
        _id: userToDelete,
        token: authState.token,
      });
      setLoading(false);
      if (status === 200) {
        setReload(true);
        setToast(true);
        setToastMessage(response.message);
      } else if (status === 401) {
        signOut();
      }
      if (response.error) {
        setToast(true);
        setToastMessage(response.error.message);
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  const confirmationModal = (_id) => {
    setOpenAlert(true);
    setUserToDelete(_id);
  };

  const handleClose = (value) => {
    setOpenEditUserModal(value);
    setUserToEdit(null);
  };

  const handleToast = (message, active) => {
    setToastMessage(message);
    setToast(active);
  };
  const optionsToolbar = [
    {
      label: "Exportar excel",
      action: (e) => {
        handleDownloadExcel({
          filename: "Administradores",
          tableBody: tableBody.current,
          tableHeader: tableHeader.current,
        });
      },
    },
    {
      label: "Agregar",
      action: (e) => {
        setOpenUserModal(true);
      },
    },
  ];

  return (
    <>
      <Drawer open={isOpen} setOpen={(value) => setIsOpen(value)} />
      <Grid container className={classes.container} style={{ flex: 1 }}>
        {loading && <Loader loading={loading} />}
        <Grid item sm={12} xs={12}>
          <div className={classes.root}>
            <ConfirmationModal
              open={openAlert}
              setOpenAlert={setOpenAlert}
              setConfirmAction={() => deleteUser()}
            />
            <Toast
              message={toastMessage}
              open={toast}
              close={() => {
                setToast(false);
              }}
            />
            {openEditUserModal && (
              <EditUser
                user={userToEdit}
                open={openEditUserModal}
                reload={() => setReload(true)}
                close={() => handleClose(false)}
                toast={(message, active) => handleToast(message, active)}
              />
            )}
            {openAddUserModal && (
              <AddUser
                open={openAddUserModal}
                close={() => setOpenUserModal(false)}
                toast={(message, active) => handleToast(message, active)}
                reload={() => setReload(true)}
              />
            )}
            <Container maxWidth={false}>
              <SimpleToolbar
                onFilter={(text) => getUsers(text)}
                isOpen={isOpen}
                setIsOpen={(value) => setIsOpen(value)}
                options={optionsToolbar}
              />
              <BaseTable tableId="adminsTable">
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell>Usuario</StyledTableCell>
                    <StyledTableCell>Correo</StyledTableCell>
                    <StyledTableCell>Estado</StyledTableCell>
                    <StyledTableCell>Opciones</StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {users.map((user, index) => (
                    <StyledTableRow hover key={user._id}>
                      <StyledTableCell
                         
                      >
                        {user.username}
                      </StyledTableCell>
                      <StyledTableCell
                         
                      >
                        {user.email}
                      </StyledTableCell>
                      <StyledTableCell
                         
                      >
                        {user.status ? "Activo" : "Inactivo"}
                      </StyledTableCell>
                      <StyledTableCell
                         
                      >
                        <EditIconButton
                          tooltipTitle="Editar laboratorio"
                          onClick={() => {
                            setOpenEditUserModal(true);
                            setUserToEdit(user);
                          }}
                        />
                        <EnableDisableIconButton
                          status={user.status}
                          onClick={() => updateStatus(user)}
                          tooltipTitleEnable="Activar usuario"
                          tooltipTitleDisable="Desactivar usuario"
                        />
                        <DeleteIconButton
                          tooltipTitle="Borrar usuario"
                          onClick={() => confirmationModal(user._id)}
                        />
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </BaseTable>
              <TablePagination
                labelRowsPerPage="Registros por página"
                component="div"
                count={count}
                onChangeRowsPerPage={(e) => {
                  setLimit(e.target.value);
                }}
                onChangePage={(e, page) => {
                  setPage(page + 1);
                }}
                page={page - 1}
                rowsPerPage={limit}
                rowsPerPageOptions={[10, 25, 50, 100]}
                classes={{ root: classes.pagination }}
              />
            </Container>
          </div>
        </Grid>
      </Grid>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
  pagination: {
    color: theme.palette.secondary.main,
    [theme.breakpoints.down("xs")]: {
      position: "absolute",
      bottom: 0,
    },
  },
}));
